import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsMitigatedTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetMitigatedType`,
    method: 'get',
  });
};

export type PreClaimsMitigatedTypesResponse = {
  key: string;
  value: string;
}[];

export const fetchPreClaimsMitigatedTypes = async (): Promise<PreClaimsMitigatedTypesResponse> => {
  const response: AxiosResponse<PreClaimsMitigatedTypesResponse> = await getPreClaimsMitigatedTypesAPI();
  return response.data;
};
